import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast, useT } from '@repo/common';

/**
 * 이미 장바구니에 있을 때 표시되는 모달
 * SuccessNotificationToast와 동일하게 아래에서 위로 올라오는 애니메이션
 */
const AlreadyInBagModal = ({ isOpen, onClose }) => {
  const t = useT();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) return undefined;

    const timer = setTimeout(() => {
      onClose && onClose();
    }, 10000);

    return () => clearTimeout(timer);
  }, [isOpen, onClose]);

  const handleViewBag = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    navigate('/community/kpathport/booking');
    onClose && onClose();
  };

  const handleClose = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    onClose && onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Desktop Toast - Bottom Center */}
      <div className='hidden tabletH:fixed tabletH:bottom-[24px] tabletH:left-1/2 tabletH:-translate-x-1/2 tabletH:z-[1000] tabletH:block'>
        <Toast
          visibleOn='desktop'
          type='info'
          state='white'
          hierarchy='mostImportant'
          title={t(
            'This item is already in your bag',
            '이미 장바구니에 있는 상품입니다',
          )}
          message=''
          onClose={handleClose}
          buttonLabel={t('View bag', '장바구니 보기')}
          onButtonClick={handleViewBag}
          direction='up'
          customWidth='auto'
        />
      </div>

      {/* Mobile Toast - Bottom Center */}
      <div className='tabletH:hidden fixed bottom-[24px] left-0 right-0 px-4 z-[9999999] flex justify-center'>
        <Toast
          visibleOn='mobile'
          type='info'
          state='white'
          hierarchy='mostImportant'
          title={t(
            'This item is already in your bag',
            '이미 장바구니에 있는 상품입니다',
          )}
          message=''
          onClose={handleClose}
          useSmallIcon={true}
          hideActions={true}
          direction='up'
          customWidth='auto'
        />
      </div>
    </>
  );
};

export default AlreadyInBagModal;
